import React, { useEffect } from 'react';
import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Switch,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { useSnackbar } from 'notistack';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import axiosWithAuth, { axiosWithAccessAndroidPOS } from '../../../services/ServiceConfig';
import { Alert } from '@material-ui/lab';
import { useAppContext } from '../../../config/AppContext';
import { useHistory } from 'react-router-dom';
import AddImage from '../../AddImage/AddImage';
import { useStoreContext } from '../../../config/StoreContext';
import { noDataAvailable } from '../../../components/NoDataAvailable';
import {
  HeaderButton,
  HeaderButtonType,
} from '../../../theme/components/buttons/HeaderButton';

interface IAndroidPOSTerminal {
  terminalName: string;
  registrationCode: string;
  venueId: string;
  storeId: string;
  locationId: string;
  isActivated: string;
  id: string;
}

const Terminals = () => {
  const history = useHistory();
  const {
    user,
    venue,
    selectedStoreId,
    allTerminals,
    getAllTerminals,
    taxRates,
    stores
  } = useAppContext();

  const {
    categories,
    fulfillmentCenters,
    products,
    selectedProductCategoryId,
    store,
  } = useStoreContext();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isAddTerminal, setIsAddTerminal] = React.useState(false);
  const [isEditTerminal, setIsEditTerminal] = React.useState(false);
  const [isDeleteTerminal, setIsDeleteTerminal] = React.useState(false);
  const [terminalName, setTerminalName] = React.useState('');
  const [terminalPin, setTerminalPin] = React.useState('');
  const [editTerminalPin, setEditTerminalPin] = React.useState('');
  const [registrationCode, setRegistrationCode] = React.useState('');
  const [selectedDeId, setSelectedDelId] = React.useState('');
  const [isPosCash, setIsPosCash] = React.useState(true);
  const [editTerminalName, setEditTerminalName] = React.useState('');
  const [editTerminalStore, setEditTerminalStore] = React.useState("");
  const [editRegistrationCode, setEditRegistrationCode] = React.useState('');
  const [isEditTerminalId, setIsEditTerminalId] = React.useState('');
  const [terminalLocationId, setTerminalLocationId] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [terminalNameError, setTerminalNameError] = React.useState(false);
  const [
    terminalRegistrationCodeError,
    setTerminalRegistrationCodeError,
  ] = React.useState(false);

  const [editTerminalNameError, setEditTerminalNameError] = React.useState(
    false,
  );
  const [
    editRegistrationCodeError,
    setEditRegistrationCodeError,
  ] = React.useState(false);

  const [showError, setShowError] = React.useState(false);
  const [showError1, setShowError1] = React.useState(false);
  const [showError2, setShowError2] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState('');

  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showImageUploadPopUp, setShowImageUploadPopUp] = React.useState(false);

  const [imageUrl, setImageUrl] = React.useState('');

  const [image, setImage] = React.useState('');
  const [storeContext, setStoreContext] = React.useState();
  const userId = window.localStorage.getItem('userId');
  const [showCartPopup, setShowCartPopup] = React.useState(false);
  const [cart, setCar] = React.useState<any>();
  const [selectTerminal, setSelectTerminal] = React.useState();
  const handleAddTerminalOpen = () => {
    setIsAddTerminal(true);
  };

  const [allAndroidPOS, setAllAndroidPOS] = React.useState<IAndroidPOSTerminal[]>();
  const [isAddingPOS, setIsAddingPOS] = React.useState(false);
  const [newPOSName, setNewPOSName] = React.useState("");
  const getAllAndroidPOS = async () => {
    const res = (await axiosWithAccessAndroidPOS.get(`AndroidPOSTerminals/forStore/${selectedStoreId}`)).data;
    setAllAndroidPOS(res);
  }
  const createAndroidPOS = async () => {
    if (!newPOSName) {
      return;
    }
    const payload = {
      terminalName: newPOSName,
      venueId: venue?.id,
      storeId: selectedStoreId,
    };
    axiosWithAccessAndroidPOS
      .post('AndroidPOSTerminals', payload)
      .then(async response => {
        handleAddPOSClose();
        await getAllAndroidPOS();
        setShowSuccess(true);
      })
      .catch(error => {
        setShowError2(true);
        setShowErrorMessage(error.response.data.messa);
      });
  };
  const handleAddPOSClose = () => {
    setNewPOSName('');
    setIsAddingPOS(false);
  }

  const handleAddTerminalClose = () => {
    setTerminalNameError(false);
    setTerminalRegistrationCodeError(false);
    setIsAddTerminal(false);
    setTerminalName('');
    setRegistrationCode('');
    setEditTerminalPin('');
  };

  const handleEditTerminalOpen = (terminal: any) => {
    setIsEditTerminalId(terminal.id);
    setEditTerminalName(terminal.terminalName);
    setEditTerminalStore(terminal.storeId);
    setEditRegistrationCode(terminal.registrationCode);
    setIsPosCash(terminal.isPOSCash);
    setEditTerminalPin(terminal.terminalPin);
    setIsEditTerminal(true);
  };

  const handleEditTerminalClose = () => {
    setIsEditTerminal(false);
  };

  const handleDeleteTerminalOpen = (terminal: any) => {
    setSelectedDelId(terminal.id);
    setIsDeleteTerminal(true);
  };

  const handleDeleteTerminalClose = () => {
    setSelectedDelId('');
    setIsDeleteTerminal(false);
  };
  const setImageFile = (file: any) => {
    if (file.name) {
      setImage(file);
    } else {
      setImage('');
    }
  };

  const createTerminal = async () => {
    if (terminalName === '' || terminalName === undefined) {
      setTerminalNameError(true);
      return;
    }
    const payload = {
      terminalName,
      userId: user,
      venueId: venue,
      storeId: selectedStoreId,
      isPosCash,
    };
    if (!isPosCash) {
      if (registrationCode === '' || registrationCode === undefined) {
        setTerminalRegistrationCodeError(true);
        return;
      }
      Object.assign(payload, { registrationCode: registrationCode });
    }
    if (terminalPin) {
      Object.assign(payload, { terminalPin: terminalPin });
    }
    axiosWithAuth
      .post('terminals', payload)
      .then(async response => {
        if (response.data.status === 403) {
          setShowError(true);
          return;
        }
        if (response.data.status === 400) {
          setShowError1(true);
          return;
        }
        setShowError(false);
        setShowError1(false);
        setShowError2(false);

        handleAddTerminalClose();
        await getAllTerminals();
        setTerminalName('');
        setRegistrationCode('');
        setTerminalPin('');
        setEditTerminalPin('');
        setShowSuccess(true);
      })
      .catch(error => {
        setShowError2(true);
        setShowErrorMessage(error.response.data.messa);
      });
  };

  const onDeleteTerminal = async () => {
    setIsDeleteTerminal(true);
    axiosWithAuth
      .delete(`terminals/${selectedDeId}`)
      .then(async response => {
        setShowSuccess(true);
        handleDeleteTerminalClose();
        setIsDeleteTerminal(false);
        const result = allTerminals.filter((terminal: any) => {
          return terminal.id !== selectedDeId;
        });
        await getAllTerminals();
      })
      .catch(error => {
      });
  };

  const onUpdateTerminal = async () => {
    if (editTerminalName === '' || editTerminalName === undefined) {
      setEditTerminalNameError(true);
      return;
    }

    if (editRegistrationCode === '' || editRegistrationCode === undefined) {
      setEditRegistrationCodeError(true);
      return;
    }

    const payload = {
      terminalName: editTerminalName,
      terminalPin: editTerminalPin,
      storeId: editTerminalStore,
    };
    axiosWithAuth
      .put(`terminals/${isEditTerminalId}`, payload)
      .then(async response => {
        setShowSuccess(true);
        setIsDeleteTerminal(false);
        setIsEditTerminal(false);
        setEditTerminalPin('');
        await getAllTerminals();
      })
      .catch(error => {
      });
  };

  useEffect(() => {
    if (allTerminals?.length < 1) {
      (async () => {
        await getAllTerminals();
      })();
    }
    (async () => {
      await getAllAndroidPOS()
    })();
    if (store && categories && products) {
      const arr: any = [];
      arr.push(
        categories,
        products,
        store,
        fulfillmentCenters,
        selectedProductCategoryId,
        taxRates,
      );
      setStoreContext(arr);
    }
  }, [store, categories, products]);

  const handleUploadImage = (terminal: any) => {
    setIsEditTerminalId(terminal.id);
    setTerminalLocationId(terminal.locationId);
    setShowImageUploadPopUp(true);
    if (terminal.image != null) {
      setImageUrl(terminal.image);
    }
  };

  const handleUploadImageCancel = () => {
    setShowImageUploadPopUp(false);
  };
  const uploadImage = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      if (image) {
        formData.append('imageFile', image);
        formData.append('locationId', terminalLocationId);
        await axiosWithAuth.put(
          `terminals/terminalImage/${isEditTerminalId}`,
          formData,
        );
        setShowSuccess(true);
        setIsDeleteTerminal(false);
        setShowImageUploadPopUp(false);
        await getAllTerminals();
        enqueueSnackbar('Image Uploaded successfully', {
          variant: 'success',
          autoHideDuration: 8000,
        });
      } else {
        enqueueSnackbar('Please add image', {
          variant: 'warning',
          autoHideDuration: 8000,
        });
      }
      setIsLoading(false);
    } catch (err) {
      setShowImageUploadPopUp(false);
      enqueueSnackbar('Error While Uploading image', {
        variant: 'error',
        autoHideDuration: 8000,
      });
      setIsLoading(false);
    }
  };

  const createAccess = async (item: any) => {
    try {
      setSelectTerminal(item);
      const check = window.localStorage.getItem('cartId');
      if (check) {
        window.localStorage.removeItem('cartId');
      }
      history.push('/terminal', { item, storeContext });
      return;
    } catch (error) {
      console.log(error.message, 'error loading');
      enqueueSnackbar(error.message, {
        variant: 'error',
        autoHideDuration: 8000,
      });
    }
  };

  return (
    <div className="store-terminals">
      {showSuccess && <Message />}
      <div className="store-terminals__section" id='add-terminal'>
        <Grid
          container={true}
          alignItems="center"
          justify="space-between"
          className="store-terminals__section-header"
        >
          <Grid item={true}>
            <Typography variant="h6">Wise POS Terminals</Typography>
          </Grid>
          <Grid item={true}>
            <HeaderButton
              icon={AddOutlinedIcon}
              onClick={handleAddTerminalOpen}
              text="Add Wise POS"
              type={HeaderButtonType.PRIMARY}
            />
          </Grid>
        </Grid>
        <Table className="generic-table">
          <TableBody>
            <TableRow classes={{ root: 'table-header' }}>
              {['Terminal Name', 'Status', 'Actions'].map(column => (
                <TableCell
                  key={column}
                  align="left"
                  size="small"
                  variant="head"
                  classes={{ root: 'table-cell' }}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
            {allTerminals.length < 1
              ? noDataAvailable(3, 'No Wise POS Terminals Added')
              : allTerminals.map((item: any, index) => {
                return (
                  <TableRow key={index} hover={true}>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }}>
                      {item.terminalName}
                    </TableCell>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }} className="store-terminals__status">
                      Connected
                    </TableCell>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }}>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={async () => {
                          await createAccess(item);
                        }}
                      >
                        <div className="icon-title-wrapper">
                          <ArrowUpwardOutlinedIcon />
                          <span className="icon-title">Access</span>
                        </div>
                      </Button>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={() => handleEditTerminalOpen(item)}
                      >
                        <div className="icon-title-wrapper">
                          <EditOutlinedIcon />
                          <span className="icon-title">Edit</span>
                        </div>
                      </Button>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={() => handleUploadImage(item)}
                      >
                        <div className="icon-title-wrapper">
                          <PhotoLibraryOutlinedIcon />
                          <span className="icon-title">Image</span>
                        </div>
                      </Button>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={() => handleDeleteTerminalOpen(item)}
                      >
                        <div className="icon-title-wrapper">
                          <DeleteOutlineOutlinedIcon />
                          <span className="icon-title">Delete</span>
                        </div>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <Dialog
          open={isAddTerminal}
          onClose={handleAddTerminalClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">ADD WISE POS</DialogTitle>
          <DialogContent>
            {showError1 && <Alert severity="error">Invalid Serial No.!</Alert>}
            {showError && <Alert severity="error">Terminal Already Exist</Alert>}
            {showError2 && <Alert severity="error">{showErrorMessage}</Alert>}

            <TextField
              margin="dense"
              id="name"
              label="Terminal Name"
              type="text"
              fullWidth={true}
              value={terminalName}
              onChange={newValue => setTerminalName(newValue.target.value)}
              required={true}
              error={terminalNameError}
            />

            <TextField
              margin="dense"
              id="name"
              label="Registration Code"
              type="text"
              fullWidth={true}
              value={registrationCode}
              disabled={isPosCash ? true : false}
              onChange={newValue => setRegistrationCode(newValue.target.value)}
              required={true}
              error={terminalRegistrationCodeError}
            />
            <label htmlFor="pos-cash-switch">For Cash Only</label>
            <Switch
              classes={{
                track: 'custom-colored-switch-track',
              }}
              checked={isPosCash}
              color="primary"
              name="alcohol"
              onChange={(event: any) => {
                if (event.target.value) setRegistrationCode('');
                setIsPosCash(prev => !prev);
              }}
              size="medium"
              value={isPosCash}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleAddTerminalClose}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button color="primary" variant="outlined" onClick={createTerminal}>
              ADD
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isEditTerminal}
          onClose={handleEditTerminalClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">EDIT TERMINAL</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="name"
              label="Terminal Name"
              type="text"
              fullWidth={true}
              value={editTerminalName}
              onChange={newValue => setEditTerminalName(newValue.target.value)}
              error={editTerminalNameError}
            />

            <TextField
              disabled={true}
              margin="dense"
              id="name"
              label="Terminal Serial Number"
              type="text"
              fullWidth={true}
              value={editRegistrationCode}
              onChange={newValue =>
                setEditRegistrationCode(newValue.target.value)
              }
              error={editRegistrationCodeError}
            />

            <FormControl required={true} className="field">
              <p className="label">Store: </p>
              <Select
                value={
                  editTerminalStore
                }
                onChange={e => {
                  setEditTerminalStore(e.target.value as string)
                }
                }
                variant="outlined"
              >
                {stores.map(store => {
                  return <MenuItem value={store.id}>{store.name}</MenuItem>
                })}
              </Select>
            </FormControl>

            <div style={{marginTop: 10}}>
              <label htmlFor="pos-cash-switch">For Cash Only</label>
              <Switch
                classes={{
                  track: 'custom-colored-switch-track',
                }}
                checked={isPosCash}
                color="primary"
                name="alcohol"
                disabled={true}
                size="medium"
                value={isPosCash}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleEditTerminalClose}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button onClick={onUpdateTerminal} color="primary" variant="outlined">
              Update
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isDeleteTerminal}
          onClose={handleDeleteTerminalClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
            DELETE TERMINAL
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ textAlign: 'center' }}
            >
              Are you sure you want to Delete the Terminal.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div style={{ textAlign: 'center' }}>
              <Button
                onClick={handleDeleteTerminalClose}
                color="primary"
                variant="outlined"
              >
                No Go Back
              </Button>
              <Button
                color="primary"
                variant="outlined"
                onClick={onDeleteTerminal}
              >
                Yes Delete
              </Button>
            </div>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showImageUploadPopUp}
          onClose={handleDeleteTerminalClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
            Upload Image
          </DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={imageUrl}
              width="120"
              style={{ objectFit: 'contain', maxHeight: '100px' }}
            />
          </div>
          {isLoading ? (
            <div
              style={{
                textAlign: 'center',
              }}
            >
              <CircularProgress size={100} />
            </div>
          ) : (
            <>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ textAlign: 'center' }}
                >
                  <AddImage
                    width={200}
                    height={160}
                    previewBottom={false}
                    showImageDetails={true}
                    getFile={setImageFile}
                    getImageURL={async (url: any) => {
                      setImageUrl(url);
                    }}
                    minHeight={600}
                    minWidth={720}
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div style={{ textAlign: 'center' }}>
                  <Button
                    onClick={handleUploadImageCancel}
                    color="primary"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={uploadImage}
                  >
                    Save
                  </Button>
                </div>
              </DialogActions>
            </>
          )}
        </Dialog>
      </div>
      <Divider className="store-terminals__divider" />
      <div className="store-terminals__section" id='add-android-pos'>
        <Grid
          container={true}
          alignItems="center"
          justify="space-between"
          className="store-terminals__section-header"
        >
          <Grid item={true}>
            <Typography variant="h6">M2 Readers</Typography>
          </Grid>
          <Grid item={true}>
            <HeaderButton
              icon={AddOutlinedIcon}
              onClick={() => setIsAddingPOS(true)}
              text="Add M2 Reader"
              type={HeaderButtonType.PRIMARY}
            />
          </Grid>
        </Grid>
        <Table className="generic-table">
          <TableBody>
            <TableRow classes={{ root: 'table-header' }}>
              {['POS Name', 'Status', 'Registration Code', 'Actions'].map(column => (
                <TableCell
                  key={column}
                  align="left"
                  size="small"
                  variant="head"
                  classes={{ root: 'table-cell' }}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
            {!allAndroidPOS || allAndroidPOS.length < 1
              ? noDataAvailable(4, 'No M2 Readers Added')
              : allAndroidPOS.map((androidTerminal: IAndroidPOSTerminal, index) => {
                return (
                  <TableRow key={index} hover={true}>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }}>
                      {androidTerminal.terminalName}
                    </TableCell>
                    <TableCell
                      align="left"
                      variant="body"
                      classes={{ root: 'table-cell' }}
                      className="store-terminals__status"
                      style={{ color: !androidTerminal.isActivated ? 'red' : '' }}
                    >
                      {androidTerminal.isActivated ? 'Activated' : 'Not Activated'}
                    </TableCell>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }}>
                      {androidTerminal.registrationCode.toUpperCase()}
                    </TableCell>
                    <TableCell align="left" variant="body" classes={{ root: 'table-cell' }}>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={() => handleEditTerminalOpen(androidTerminal)}
                      >
                        <div className="icon-title-wrapper">
                          <EditOutlinedIcon />
                          <span className="icon-title">Edit</span>
                        </div>
                      </Button>
                      <Button
                        size="small"
                        classes={{ root: 'action-buttons' }}
                        onClick={() => handleDeleteTerminalOpen(androidTerminal)}
                      >
                        <div className="icon-title-wrapper">
                          <DeleteOutlineOutlinedIcon />
                          <span className="icon-title">Delete</span>
                        </div>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <Dialog
          open={isAddingPOS}
          onClose={handleAddPOSClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">ADD M2 READER</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="name"
              label="Terminal Name"
              type="text"
              fullWidth={true}
              value={newPOSName}
              onChange={newValue => setNewPOSName(newValue.target.value)}
              required={true}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleAddPOSClose}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button color="primary" variant="outlined" onClick={createAndroidPOS}>
              ADD
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};
export default Terminals;

const Message = () => {
  const [alert, setAlert] = React.useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlert(false);
    }, 3000);

    // To clear or cancel a timer, you call the clearTimeout(); method,
    // passing in the timer object that you created into clearTimeout().

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {alert && (
        <Alert severity="success" variant="filled">
          Success!
        </Alert>
      )}
    </>
  );
};
